import React from 'react';

function ClockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#3D3D3D"
        d="M12 24a12 12 0 1112-12 12.013 12.013 0 01-12 12zm0-22a10 10 0 1010 10A10.011 10.011 0 0012 2z"
      ></path>
      <path fill="#3D3D3D" d="M7.947 15.598l-1.061-1.696L11 11.325V6h2v6.433l-5.053 3.165z"></path>
    </svg>
  );
}

export default ClockIcon;
